import { useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Parser from 'html-react-parser';
import ComputerIcon from '@mui/icons-material/Computer';

import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import MuiWrapper from '../../../layout/MuiWrapper';
import useNotificationModal, {
  LOG_TYPE,
} from '../../../hooks/useNotificationModal';
import Loading from '../../../components/Loading';

const NotificationModal = () => {
  const {
    isOpenModal,
    handleCloseModal,
    notification,
    isNotificationLoading,
    selectedType,
  } = useNotificationModal();
  const investmentsRef = useRef(null);
  const followsRef = useRef(null);
  const worldStockMarketRef = useRef(null);
  const commodityMarketRef = useRef(null);
  const [selectedSection, setSelectedSection] = useState('investmentsRef');

  const getTitle = () => {
    return (
      <div>
        <div>
          <ComputerIcon /> Thông báo
        </div>
      </div>
    );
  };

  const handleTabClick = (targetRef, _tab) => {
    targetRef.current.scrollIntoView();
    setSelectedSection(_tab);
  };

  const renderStartSession = () => {
    if (
      notification?.follow?.length &&
      notification?.message?.indexOf('follow-container') !== -1
    ) {
      const newMessage = notification.message.split(
        '<div class="hidden follow-container"></div>'
      );
      return (
        <Box component="div">
          {Parser(newMessage[0])}
          <div className="mt-4">
            <p className="font-bold">Danh mục đầu tư:</p>
            {notification?.follow.map((follow, index) => (
              <div key={index} className="ml-3">
                {Parser(follow.message)}
              </div>
            ))}
          </div>
          {Parser(newMessage[1])}
        </Box>
      );
    }
    return (
      <Box className="notification-content">
        <div>{Parser(notification.message)}</div>
      </Box>
    );
  };

  return (
    <MuiWrapper>
      <Modal
        isOpen={isOpenModal}
        onCloseModal={handleCloseModal}
        title={getTitle()}
        mainContentClassName="modal-center max-w-[90vw] m-auto w-full note-modal"
        spacingMainContentClassName="m-auto"
        useHeaderBg
        childrenClassName="mt-1"
      >
        <Box>
          <div>
            {notification?.otherInfo?.investments?.length ||
            notification?.otherInfo?.follows?.length ||
            (notification?.otherInfo?.worldStockMarket?.length &&
              notification?.otherInfo?.worldStockMarket?.[0]?.type) ||
            (notification?.otherInfo?.commodityMarket?.length &&
              notification?.otherInfo?.commodityMarket?.[0]?.type) ? (
              <div className="flex gap-2 flex-wrap slg:flex-nowrap pb-3">
                {notification?.otherInfo?.investments?.length ? (
                  <Button
                    type="button"
                    variant={
                      selectedSection === 'investmentsRef'
                        ? 'contained'
                        : 'outlined'
                    }
                    onClick={() =>
                      handleTabClick(investmentsRef, 'investmentsRef')
                    }
                    className="whitespace-nowrap"
                  >
                    Danh mục đầu tư
                  </Button>
                ) : null}
                {notification?.otherInfo?.follows?.length ? (
                  <Button
                    type="button"
                    variant={
                      selectedSection === 'followsRef'
                        ? 'contained'
                        : 'outlined'
                    }
                    onClick={() => handleTabClick(followsRef, 'followsRef')}
                    className="whitespace-nowrap"
                  >
                    Danh mục theo dõi
                  </Button>
                ) : null}
                {notification?.otherInfo?.worldStockMarket?.length &&
                notification?.otherInfo?.worldStockMarket?.[0]?.type ? (
                  <Button
                    type="button"
                    variant={
                      selectedSection === 'worldStockMarketRef'
                        ? 'contained'
                        : 'outlined'
                    }
                    onClick={() =>
                      handleTabClick(worldStockMarketRef, 'worldStockMarketRef')
                    }
                    className="whitespace-nowrap"
                  >
                    Thị trường chứng khoán thế giới
                  </Button>
                ) : null}
                {notification?.otherInfo?.commodityMarket?.length &&
                notification?.otherInfo?.commodityMarket?.[0]?.type ? (
                  <Button
                    type="button"
                    variant={
                      selectedSection === 'commodityMarketRef'
                        ? 'contained'
                        : 'outlined'
                    }
                    onClick={() =>
                      handleTabClick(commodityMarketRef, 'commodityMarketRef')
                    }
                    className="whitespace-nowrap"
                  >
                    Thị trường hàng hóa
                  </Button>
                ) : null}
              </div>
            ) : null}
          </div>
          <div className="relative max-h-[65vh] overflow-y-auto">
            <Loading isLoading={isNotificationLoading} className="white" />
            {notification ? (
              <div id="notificationModal">
                {selectedType === LOG_TYPE.startSession
                  ? renderStartSession()
                  : null}
                {selectedType === LOG_TYPE.endSession ? (
                  <Box className="notification-content">
                    <div>{Parser(notification.message)}</div>
                  </Box>
                ) : null}
              </div>
            ) : null}
          </div>
        </Box>
      </Modal>
    </MuiWrapper>
  );
};

export default NotificationModal;
